import * as React from "react";

function EmptyBasket() {

	return (
		<React.Fragment>
			<div className="c-section c-section--center c-section--tight-top c-section--empty-wishlist">
				<div className="c-section__inner">
					<p className="h1 u-mb15">There are no items in your wishlist.</p>
					<div className="c-cms u-mb20">
						<p>Click the heart on any product across the website to start creating your wishlist.</p>
					</div>
					<p><a href="/" className="c-button c-button--large c-button--emphasize" data-test="wishlist-continue-shopping-link-small">Continue shopping</a></p>
				</div>
			</div>
		</React.Fragment>
	);

}

export default EmptyBasket;
